/** @jsxImportSource @emotion/react */
'use memo'

import { PlayerProvider } from 'src/pages/Player/context/PlayerContext'
import { UIProvider } from 'src/pages/Player/context/UIContext'
import PlayerStatsTab from 'src/pages/Player/components/StatsTab'

interface Props {
  playerId: string
}

const StatsTab: React.FC<Props> = ({ playerId }) => (
  <PlayerProvider playerId={playerId}>
    <UIProvider>
      <PlayerStatsTab />
    </UIProvider>
  </PlayerProvider>
)

export default StatsTab
